import { isJustBeforeViewport } from "../../../resources/js/helper/helper";

(function () {
  /**
   * Eventlistener
   */
  const mbLogoSliderSingle = document.querySelectorAll(".mb-logo-slider");
  if (!mbLogoSliderSingle.length) return;
  let totalLaodedSliders = 0;

  // On load
  loopOverSliders();

  // On scroll
  document.addEventListener("scroll", loopOverSliders);

  function loopOverSliders() {
    for (let i = 0; i < mbLogoSliderSingle.length; i++) {
      totalLaodedSliders += handleLogoSlider(mbLogoSliderSingle[i]);

      // remove event listener after all sliders loaded
      if (totalLaodedSliders == mbLogoSliderSingle.length) {
        document.removeEventListener("scroll", loopOverSliders);
      }
    }
  }
})();

/**
 * Handle slider on reaching viewport
 * lazyload all images
 * and trigger run function
 * @param {dom} mbSlider
 * @return {int}
 */
function handleLogoSlider(mbSlider) {
  if (
    !mbSlider.classList.contains("mb-slider-run") &&
    !mbSlider.classList.contains("mb-slider-init") &&
    isJustBeforeViewport(mbSlider, 200)
  ) {
    mbSlider.classList.add("mb-slider-init");

    // lazyload image
    let allImages = mbSlider.querySelectorAll("object, picture img, svg");
    let imagesLoadedCount = 0;
    let imagesCount = allImages.length;
    let image;

    // fallback if not all images fires load event
    let fallbackTimeout = setTimeout(function () {
      runSlider(mbSlider);
    }, 2000);

    // listener for image load
    for (let y = 0; y < allImages.length; y++) {
      image = allImages[y];
      allImages[y].style.display = "block";

      image.addEventListener("load", imageLoaded, false);

      if (image.complete) {
        imageLoaded.call(image);
        image.removeEventListener("load", imageLoaded, false);
      }

      function imageLoaded() {
        imagesLoadedCount++;
        if (imagesCount == imagesLoadedCount) {
          runSlider(mbSlider);
          clearTimeout(fallbackTimeout);
        }
      }
    }

    return 1;
  }

  return 0;
}

/**
 * run slider after all images are loaded
 * @param {dom} mbSlider
 */
function runSlider(mbSlider) {
  const sliderWrapper = mbSlider.querySelector(".mb-logo-slider-wrapper");

  if (!sliderWrapper) return;

  // fix wrapper width
  sliderWrapper.style.width = sliderWrapper.scrollWidth + "px";
  // set animation duration depending on wrapper width
  const speed =
    mbSlider.dataset.speed !== undefined
      ? parseInt(mbSlider.dataset.speed)
      : 150;

  sliderWrapper.style.animationDuration =
    sliderWrapper.scrollWidth / speed + "s";

  // clone wraper for seamless animation
  const sliderWrapperClone = sliderWrapper.cloneNode(true);
  sliderWrapperClone.classList.add("clone");
  mbSlider.appendChild(sliderWrapperClone);

  // do not animate if wrapper smaller dan viewport width
  if (window.innerWidth < mbSlider.scrollWidth) {
    mbSlider.classList.remove("mb-slider-init");
    mbSlider.classList.add("mb-slider-run");
  }
}
